import React from "react";
import Select from "./Select/Select";
import classNames from "classnames";

const Input = ({
  label,
  value,
  onChange,
  placeholder,
  inputType,
  htmlFor,
  ref,
  className,
  rightIcon,
  disabled,
  type,
  selectOptions,
  textOptions,
  onBlur,
}) => {
  let element = null;

  if (type === "select") {
    element = (
      <Select
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        ref={ref}
        disabled={disabled}
        {...selectOptions}
      />
    );
  } else if (type === "text") {
    element = (
      <div className="relative">
        <textarea
          placeholder="Write about your experience."
          className="px-4 py-3 resize-none w-full bg-white rounded-[10px] border border-neutral-200/60 font-custom  p-2.5 text-sm text-dark_black focus:outline-accents"
          rows={3}
          onChange={onChange}
          value={value}
          disabled={disabled}
        />
        <div className="absolute bottom-2 right-2 text-stone-300 text-[10px] font-medium">
          {textOptions && textOptions.characterLimit} characters
        </div>
      </div>
    );
  } else {
    element = (
      <div className="relative">
        <input
          type={inputType}
          value={value}
          onChange={onChange}
          className={classNames(
            "w-full font-custom  font-semibold  border-neutral-200 border-opacity-60 border border-[#7953D233] text-dark_black text-xs rounded-[10px] p-2 px-5 py-[12px] pl-3 focus:outline-none ",
            className
          )}
          placeholder={placeholder}
          ref={ref}
          disabled={disabled}
          onBlur={onBlur}
        /> 
        {rightIcon && (
          <div className="absolute right-0 bottom-2.5 text-stone-500 mb-1 mr-2" style={{fontSize:'10px'}}>{rightIcon}</div>
        )}
      </div>
    );
  }

  return (
    <div className="form-control">
      {label && (
        <label
          htmlFor={htmlFor}
          className="font-custom block mb-2 text-sm font-semibold text-[#492897]"
        >
          {label}
        </label>
      )}
      {element}
    </div>
  );
};

export default Input;
